import { ReactNode, createContext, useContext, useMemo, useState } from 'react';
import { EventType } from 'types/domain';

type Step = 'start' | 'info' | 'addFeatures' | 'newTitle' | 'success';

const campaignTypePosthog: Record<EventType, string> = {
    collect: 'Form',
    fundraise: 'Page',
    event: 'Event',
    general: 'General',
};

interface ICreateCampaignDialogContext {
    currentStep: Step;
    setStep: (step: Step) => void;
}

interface CreateCampaignDialogForm {
    campaignName: string;
    type: EventType;
    enableTeamFundraising: boolean;
    enableAuction: boolean;
}

const CreateCampaignDialogContext = createContext<ICreateCampaignDialogContext>({
    currentStep: 'start',
    setStep: () => {},
});

const useCreateCampaignDialogContext = () => {
    const context = useContext(CreateCampaignDialogContext);
    if (!context) {
        throw new Error(
            'useCreateCampaignDialogContext must be used within a CreateCampaignDialogProvider',
        );
    }
    return context;
};

interface CreateCampaignDialogProviderProps {
    children: ReactNode;
}
const CreateCampaignDialogProvider = ({ children }: CreateCampaignDialogProviderProps) => {
    const [step, setStep] = useState<Step>('start');

    const ctx = useMemo(
        () => ({
            currentStep: step,
            setStep,
        }),
        [step],
    );

    return (
        <CreateCampaignDialogContext.Provider value={ctx}>
            {children}
        </CreateCampaignDialogContext.Provider>
    );
};

export { CreateCampaignDialogProvider, useCreateCampaignDialogContext, campaignTypePosthog };
export type { CreateCampaignDialogForm };
